module.exports = __webpack_public_path__ + "media/images/dropdown-closed-ee45728b.svg";